import { updateProfile, getListUser, getDetailUser, setBlockUser, setUnblockUser,
  createUser, updateUser, deleteUserByEmail, deleteUserAdminByEmail,
  deleteUserById, changePasswordUserAdmin, changePasswordUserArtist, acceptToc, updateBank, getListUserApp,
  getDetailUserApp, getListTransactionUserByType, resendEmail, getListUserAppDeleted, getDetailUserDeleted, setUserPremium } from '@/services/user';

const getters = {
  listUser: state => state.listUser,
  listUserApp: state => state.listUserApp,
  listUserAppDeleted: state => state.listUserAppDeleted,
  listUserSong: state => state.listUserSong,
  listUserAlbum: state => state.listUserAlbum,
  getUser: state => state.user,
  per_page: state => state.per_page,
};

const actions = {
  async requestUpdateProfile({ commit, dispatch, rootGetters }, user) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      response = await updateProfile({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, user);
      dispatch('AuthModule/requestDetailUser', null, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message} : ${user.email}`, errorCode: 'ER-AUTH-02' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async requestUpdateBank({ commit, dispatch, rootGetters }, bank) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      response = await updateBank({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, bank);
      dispatch('AuthModule/requestDetailUser', null, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-02' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async acceptToc({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      response = await acceptToc({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      localStorage.setItem('isUpdateTnc', false);
      commit('AuthModule/UPDATE_TOC', { toc: false }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-02' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async requestListUser({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListUser({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_USER', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListUserApp({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListUserApp({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_USER_APP', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListUserAppDeleted({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListUserAppDeleted({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_USER_APP_DELETED', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCreateUser({ commit, dispatch, rootGetters }, { user, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await createUser({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, user);
      dispatch('requestListUser', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUpdateUser({ commit, dispatch, rootGetters }, { user, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await updateUser({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, user);
      dispatch('requestListUser', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailUser({ commit, rootGetters }, idUser) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getDetailUser({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, idUser);
      commit('SET_DETAIL_USER', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailUserApp({ commit, rootGetters }, idUser) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getDetailUserApp({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, idUser);
      commit('SET_DETAIL_USER_APP', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailUserAppDeleted({ commit, rootGetters }, idUser) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getDetailUserDeleted({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, idUser);
      commit('SET_DETAIL_USER_APP', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestBlockUser({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setBlockUser({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListUserApp', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestUnblockUser({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setUnblockUser({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListUserApp', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestDeleteUser({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteUserById({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListUserApp', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeleteUserByEmail({ commit, dispatch, rootGetters }, { email, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteUserAdminByEmail({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, email);
      dispatch('requestListUser', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListTransactionsUserAlbum({ commit, rootGetters }, { filter, user }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListTransactionUserByType({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, user.id, 2, filter);
      commit('SET_LIST_USER_ALBUM', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListTransactionsUserSong({ commit, rootGetters }, { filter, user }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListTransactionUserByType({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, user.id, 1, filter);
      commit('SET_LIST_USER_SONG', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestChangePasswordUser({ commit, rootGetters }, user) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      let response;
      if (isArtist) {
        response = await changePasswordUserArtist({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, user);
      } else {
        response = await changePasswordUserAdmin({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, user);
      }
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestResendEmail({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await resendEmail({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListUserApp', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestSetUserPremium({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setUserPremium({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListUserApp', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_USER(state, listUser) {
    state.listUser = listUser;
  },
  SET_LIST_USER_APP(state, listUser) {
    state.listUserApp = listUser;
  },
  SET_LIST_USER_APP_DELETED(state, listUserAppDeleted) {
    state.listUserAppDeleted = listUserAppDeleted;
  },
  SET_LIST_USER_SONG(state, listUserSong) {
    state.listUserSong = listUserSong;
  },
  SET_LIST_USER_ALBUM(state, listUserAlbum) {
    state.listUserAlbum = listUserAlbum;
  },
  SET_DETAIL_USER(state, user) {
    state.user = user;
  },
  SET_DETAIL_USER_APP(state, user) {
    state.user = user;
  },
};

export default {
  namespaced: true,
  state: {
    listUser: [],
    listUserApp: [],
    listUserAppDeleted: [],
    listUserSong: [],
    listUserAlbum: [],
    per_page: 6,
    user: {
      id: 1,
      name: '',
      email: '',
      dob: '',
      bio: '',
      genre: 'M',
      avatar: '',
    },
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/User/index.js